import type { IntlMessage } from '@rovo-extension/i18n';
import { defineMessages } from 'react-intl';

type MessageKey = 'giveFeedback' | 'whatsNew';

export const messages: Record<MessageKey, IntlMessage> = defineMessages({
	giveFeedback: {
		id: 'rovo-extension.profile.give-feedback-button.label',
		defaultMessage: 'Give feedback',
		description: "Label for the 'Give feedback' button in the profile menu",
	},
	whatsNew: {
		id: 'rovo-extension.profile.whats-new-button.label',
		defaultMessage: "What's New",
		description: "Label for the 'What's new' button in the profile menu",
	},
});
